import styled, { css } from 'styled-components';

import BlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';

import { LoyaltyLoader } from '../loyalty-loader';

export const IncentivesContainer = css`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const StyledBlockRenderer = styled(BlockRenderer)`
  margin: 0;
  font-size: 0.8125rem;
`;

export const LoyaltyIncentivesContainer = styled.div`
  ${IncentivesContainer}
  flex-direction: column;
`;

export const StyledLoyaltyLoader = styled(LoyaltyLoader)`
  height: 80vh;
`;

export const TabContainer = styled.div`
  margin-block-end: 1rem;

  ${Styles.desktop} {
    width: 27.5rem;
  }
`;

export const TabDisclaimer = styled.div`
  display: flex;
  padding: 1rem;
  background: ${primitive.$blackOpacity4};
  font-size: 0.8rem;
  line-height: 1rem;
  gap: 0.6rem;
  margin-block-start: -1rem;

  ${Styles.desktop} {
    width: 27.5rem;
  }
`;

export const OffersSkeletonPromoCode = styled.div`
  padding: 1rem;
  display: flex;
  column-gap: 1rem;
  align-items: center;

  & > span > span {
    border-radius: 1rem;
  }
`;

export const OffersSkeletonTabs = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 1rem;
  border-block-end: 3px solid #0000000a;
  max-width: 450px;

  & > span > span {
    border-radius: 1rem;
  }
`;

export const OffersIncentiveDetailsContainerSkeleton = styled.div`
  display: flex;
  row-gap: 1rem;
  flex-direction: column;
  margin: 0 auto;
  max-width: 670px;
  align-items: center;

  & > span > span {
    border-radius: 1rem;
    text-align: center;
  }
`;

export const OffersIncentiveDetailsDescriptionSkeleton = styled(
  OffersIncentiveDetailsContainerSkeleton
)`
  row-gap: 0;
`;
